/**
 * AIT file format constants.
 */

/** Magic bytes identifying AIT files ("AITBUNDL") */
export const MAGIC = new Uint8Array([0x41, 0x49, 0x54, 0x42, 0x55, 0x4e, 0x44, 0x4c]);
export const MAGIC_STRING = "AITBUNDL";
export const MAGIC_SIZE = 8;

/** Current format version */
export const FORMAT_VERSION = 1;

/** Header sizes (in bytes) */
export const VERSION_SIZE = 4;
export const LENGTH_SIZE = 8;
export const HEADER_SIZE = MAGIC_SIZE + VERSION_SIZE + LENGTH_SIZE; // 20 bytes

